export enum ProjectHoursBillingType {
  LIST_ALL_SERVICES = 'LIST_ALL_SERVICES',
  GROUPED_BY_USER = 'GROUPED_BY_USER',
  GROUPED_BY_ARTICLE = 'GROUPED_BY_ARTICLE',
  GROUPED_BY_ORDER_CONFIRMATION_POSITION = 'GROUPED_BY_ORDER_CONFIRMATION_POSITION',
}
